import script from "./PortfolioAlumni.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfolioAlumni.vue?vue&type=script&lang=ts&setup=true"

import "./PortfolioAlumni.vue?vue&type=style&index=0&id=763e5dc0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763e5dc0"]])

export default __exports__